import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { Box, Button, FormControl, FormHelperText, Stack, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { Controller, useForm } from 'react-hook-form';
import ReactSelect from 'react-select';
import EmployeeAutocomplete from '../../components/common/EmployeeAutocomplete';
import * as Yup from 'yup';
import ApiErrorMessage from '../../components/error/ApiErrorMessage';
import { rankDataOptions } from '../../utils/utils';

const validationSchema = Yup.object().shape({
    employee: Yup.string().required('Employee is required').nullable(),
    rank: Yup.string().required('Rank is required').nullable(),
});

const AddApprovalType = ({ handleAddSubmit, handleError }) => {

    //Context

    //react-hook-form
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onChange',
    });

    return (
        <Box component={'form'} onSubmit={handleSubmit(handleAddSubmit)} sx={{ minHeight: 350 }}>
            <Controller
                render={({ field, formState }) => (
                    <FormControl fullWidth size="small">
                        <Typography color={!!formState.errors?.employee ? red[700] : undefined}>
                            Select Employee*
                        </Typography>
                        <EmployeeAutocomplete
                            value={field.value}
                            onChange={(id) => field.onChange(id)}
                            onBlur={field.onBlur}
                            inputRef={field.ref}
                            error={!!formState.errors?.employee}
                        />
                        {!!formState.errors?.employee ? (
                            <FormHelperText error>{errors?.employee?.message}</FormHelperText>
                        ) : (
                            ''
                        )}
                    </FormControl>
                )}
                name="employee"
                control={control}
                defaultValue=""
            />
            <Controller
                render={({ field, formState }) => (
                    <FormControl fullWidth size={'small'} sx={{ mt: 2 }}>
                        <Typography color={!!formState.errors?.rank ? red[700] : undefined}>
                            Rank*
                        </Typography>
                        <ReactSelect
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    '&:hover': { borderColor: 'gray' }, // border style on hover
                                    border: !!formState.errors?.rank
                                        ? '1px solid red'
                                        : '1px solid lightgray', // default border color
                                    boxShadow: 'none', // no box-shadow
                                }),
                            }}
                            {...field}
                            options={rankDataOptions}
                            className="basic-multi-select"
                            isClearable={true}
                            isSearchable={true}
                            classNamePrefix="select-user"
                            value={
                                field?.value !== ''
                                    ? rankDataOptions?.filter(
                                          (row) => row?.value === field?.value
                                      )[0]
                                    : null
                            }
                            onChange={(selectedOption) => {
                                field.onChange(selectedOption?.value);
                            }}
                        />
                        {!!formState.errors?.rank ? (
                            <FormHelperText error>{errors?.rank?.message}</FormHelperText>
                        ) : (
                            ''
                        )}
                    </FormControl>
                )}
                name="rank"
                control={control}
                defaultValue=""
            />

            <ApiErrorMessage handleError={handleError} />
            <Stack
                justifyContent={'end'}
                direction={'row'}
                flexWrap={'wrap'}
                gap={1.5}
                container
                spacing={2}
                sx={{ mt: 10, mb: 2 }}
            >
                <Button
                    variant="contained"
                    onClick={() => reset()}
                    color="inherit"
                    sx={{ minWidth: 130 }}
                >
                    Reset
                </Button>
                <Button
                    variant="contained"
                    type="submit"
                    sx={{ minWidth: 130, ml: '0 !important' }}
                >
                    Add
                </Button>
            </Stack>
        </Box>
    );
};

export default AddApprovalType;
